/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/getUsdRate */
import{ExchangeRate as t}from"../rate/ExchangeRate.mjs";function r(){return t.get("usd")}export{r as getUsdRate};
//# sourceMappingURL=getUsdRate.mjs.map